// auth types
export default {
  GET_USER: 'GET_USER',
  LOGIN_USER: 'LOGIN_USER',
  LOGOUT_USER: 'LOGOUT_USER',
  SET_TOKEN: 'SET_TOKEN',
};
